import { AuthUser, DashboardProfile, Payment, Subscription } from 'types/user';

const ACCESS_STATUSES = new Set(['active', 'completed', 'paid', 'succeeded']);

const normalizeStatus = (status: string) => status.trim().toLowerCase();

export const hasUserSubscriptionAccess = (user: AuthUser | null) => {
  if (!user) return false;

  const planId = user.plan_id ?? user.user_meta?.plan_id;
  const subscriptionStatus = user.user_meta?.subscription_status;

  return Boolean(planId) && Boolean(
    subscriptionStatus && ACCESS_STATUSES.has(normalizeStatus(subscriptionStatus))
  );
};

export const hasActiveSubscription = (subscriptions: Subscription[]) =>
  subscriptions.some((subscription) => ACCESS_STATUSES.has(normalizeStatus(subscription.status)));

export const hasActivePayment = (payments: Payment[]) =>
  payments.some((payment) => ACCESS_STATUSES.has(normalizeStatus(payment.status)));

export const hasDashboardAccess = (dashboard: DashboardProfile) =>
  hasActiveSubscription(dashboard.subscriptions) || hasActivePayment(dashboard.payments);
